/* ============================================
   LITHE CURATION — Theme JS
   GSAP ScrollTrigger animations
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ============================================
     WAIT FOR GSAP TO LOAD
     ============================================ */
  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initGSAP, 50);
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    initAnimations();
  }

  initGSAP();

  /* ============================================
     NAV SCROLL BEHAVIOR
     ============================================ */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 30);
    }, { passive: true });
  }

  /* ============================================
     MOBILE MENU
     ============================================ */
  const hamburger = document.getElementById('hamburger');
  const mobileNav = document.getElementById('mobile-nav');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      document.body.classList.toggle('menu-open', isOpen);
      // Animate hamburger lines
      const lines = hamburger.querySelectorAll('span');
      if (isOpen) {
        gsap && gsap.to(lines[0], { rotation: 45, y: 6, duration: 0.3 });
        gsap && gsap.to(lines[1], { opacity: 0, duration: 0.2 });
        gsap && gsap.to(lines[2], { rotation: -45, y: -6, duration: 0.3 });
      } else {
        gsap && gsap.to(lines, { rotation: 0, y: 0, opacity: 1, duration: 0.3 });
      }
    });

    // Close on link click
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.classList.remove('menu-open');
        const lines = hamburger.querySelectorAll('span');
        gsap && gsap.to(lines, { rotation: 0, y: 0, opacity: 1, duration: 0.3 });
      });
    });
  }

  /* ============================================
     CART DRAWER
     ============================================ */
  window.openCart = function() {
    document.getElementById('cart-drawer')?.classList.add('open');
    document.getElementById('cart-overlay')?.classList.add('open');
    document.body.classList.add('cart-open');
  };

  window.closeCart = function() {
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.getElementById('cart-overlay')?.classList.remove('open');
    document.body.classList.remove('cart-open');
  };

window.removeCartItem = async function(key) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      const cart = await res.json();
      updateCartUI(cart);
      renderCartItems(cart);
    } catch(e) { console.error(e); }
  };

  window.addToCart = async function(variantId, btn) {
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      const cart = await (await fetch('/cart.js')).json();
      updateCartUI(cart);
      renderCartItems(cart);
      openCart();
    } catch(e) { console.error(e); }
    finally {
      if (btn) setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 600);
    }
  };

  function renderCartItems(cart) {
    const container = document.getElementById('cart-items-container');
    if (!container) return;
    if (cart.item_count === 0) {
      container.innerHTML = '<div class="cart-empty"><p class="cart-empty-text">Your selection is empty</p><span class="cart-empty-sub">Explore rare archive pieces in the shop</span></div>';
      return;
    }
    container.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-img">${item.image ? `<img src="${item.image}" alt="${item.title}" width="80">` : ''}</div>
        <div class="cart-item-info">
          <div class="cart-item-brand">${item.vendor}</div>
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-price">${(item.final_price/100).toLocaleString('en-US',{style:'currency',currency:'USD'})}</div>
        </div>
        <button class="cart-item-remove" onclick="window.removeCartItem('${item.key}')" aria-label="Remove item">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><line x1="1" y1="1" x2="11" y2="11" stroke="currentColor" stroke-width="1.2"/><line x1="11" y1="1" x2="1" y2="11" stroke="currentColor" stroke-width="1.2"/></svg>
        </button>
      </div>`).join('')
      + `<div class="cart-footer-inner" style="padding-top:24px;margin-top:24px;border-top:1px solid var(--gold-light);">
          <div class="cart-subtotal" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;font-size:12px;color:var(--dark-gray);">
            <span>Subtotal</span>
            <span style="font-family:var(--serif);font-size:20px;font-weight:300;color:var(--navy);">${(cart.total_price/100).toLocaleString('en-US',{style:'currency',currency:'USD'})}</span>
          </div>
          <a href="/checkout" class="btn-checkout" style="display:block;padding:16px;background:var(--navy);color:var(--gold);font-size:10px;letter-spacing:3px;text-transform:uppercase;text-align:center;margin-bottom:10px;">Proceed to Checkout →</a>
          <a href="/cart" style="display:block;text-align:center;font-size:10px;letter-spacing:2px;text-transform:uppercase;color:var(--mid-gray);padding:6px;">View Cart</a>
        </div>`;
    const total = document.getElementById('cart-total');
    if (total) total.textContent = (cart.total_price/100).toLocaleString('en-US',{style:'currency',currency:'USD'});
  }

  function updateCartUI(cart) {
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
    const totalEl = document.getElementById('cart-total');
    if (totalEl) totalEl.textContent = new Intl.NumberFormat('en-US', {style:'currency',currency:cart.currency||'USD'}).format(cart.total_price/100);
  }


  /* ============================================
     MAIN ANIMATIONS (called after GSAP loads)
     ============================================ */
  function initAnimations() {

    /* ---- PAGE ENTRANCE ---- */
    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    // Header
    tl.from('.site-header', {
      y: -20,
      opacity: 0,
      duration: 0.9,
      clearProps: 'all'
    });

    // Hero left side — staggered text reveal
    const heroEyebrow = document.querySelector('.hero-eyebrow');
    const heroHeadlineWords = document.querySelectorAll('.hero-headline .word');
    const heroDesc = document.querySelector('.hero-description');
    const heroCta = document.querySelector('.hero-cta');

    if (heroEyebrow) {
      tl.from(heroEyebrow, {
        y: 20, opacity: 0, duration: 0.7
      }, '-=0.4');
    }

    if (heroHeadlineWords.length) {
      tl.from(heroHeadlineWords, {
        y: 60, opacity: 0, duration: 1,
        stagger: 0.12,
        ease: 'power4.out'
      }, '-=0.3');
    }

    if (heroDesc) {
      tl.from(heroDesc, {
        y: 20, opacity: 0, duration: 0.7
      }, '-=0.5');
    }

    if (heroCta) {
      tl.from(heroCta, {
        y: 16, opacity: 0, duration: 0.6
      }, '-=0.4');
    }

    // Hero right image cells
    const heroCells = document.querySelectorAll('.hero-img-cell');
    if (heroCells.length) {
      tl.from(heroCells, {
        opacity: 0,
        scale: 1.06,
        duration: 1.2,
        stagger: 0.1,
        ease: 'power2.out'
      }, '-=0.8');
    }

  
  

    /* ---- MARQUEE PAUSE ON HOVER ---- */
    const marqueeTrack = document.querySelector('.marquee-track');
    if (marqueeTrack) {
      marqueeTrack.addEventListener('mouseenter', () => {
        marqueeTrack.style.animationPlayState = 'paused';
      });
      marqueeTrack.addEventListener('mouseleave', () => {
        marqueeTrack.style.animationPlayState = 'running';
      });
    }

    /* ---- SECTION TITLES ---- */
    document.querySelectorAll('.section-title, .philosophy-headline, .about-hero-title, .about-lead, .about-section-title, .contact-title, .collection-title, .values-title, .product-title').forEach(el => {
      gsap.from(el, {
        y: 50,
        opacity: 0,
        duration: 1.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      });
    });

    /* ---- EYEBROW LABELS ---- */
    document.querySelectorAll('.eyebrow').forEach(el => {
      gsap.from(el, {
        y: 14, opacity: 0, duration: 0.7,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          toggleActions: 'play none none none'
        }
      });
    });

    /* ---- FEATURED GRID ITEMS ---- */
    const featuredItems = document.querySelectorAll('.featured-item');
    if (featuredItems.length) {
      gsap.from(featuredItems, {
        y: 60,
        opacity: 0,
        duration: 1,
        stagger: 0.12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: '.featured-grid',
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      });
    }

    /* ---- PRODUCT CARDS STAGGER ---- */
    document.querySelectorAll('.products-grid').forEach(grid => {
      const cards = grid.querySelectorAll('.product-card');
      if (!cards.length) return;
      gsap.from(cards, {
        y: 0,
        opacity: 0,
        scale: 0.95,
        duration: 0.8,
        stagger: 0.02,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: grid,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      });
    });

    /* ---- STATS ---- */
    const statNumbers = document.querySelectorAll('.stat-number, .value-number');
    statNumbers.forEach(el => {
      gsap.from(el, {
        opacity: 0,
        y: 30,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          toggleActions: 'play none none none'
        }
      });
    });

    /* ---- PHILOSOPHY TEXT ---- */
    const philText = document.querySelector('.philosophy-text');
    if (philText) {
      gsap.from(philText, {
        y: 30, opacity: 0, duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: philText,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      });
    }

    /* ---- STATS GRID ---- */
    const statsGrid = document.querySelector('.stats-grid');
    if (statsGrid) {
      gsap.from(statsGrid.children, {
        opacity: 0,
        y: 40,
        duration: 0.8,
        stagger: 0.12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: statsGrid,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      });
    }

    /* ---- PHILOSOPHY SECTION PARALLAX ---- */
    gsap.to('.philosophy-section', {
      backgroundPositionY: '30px',
      ease: 'none',
      scrollTrigger: {
        trigger: '.philosophy-section',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
      }
    });

    /* ---- ABOUT HERO BG TEXT PARALLAX ---- */
    const aboutBg = document.querySelector('.about-hero-bg');
    if (aboutBg) {
      gsap.to(aboutBg, {
        y: -80,
        ease: 'none',
        scrollTrigger: {
          trigger: '.about-hero',
          start: 'top top',
          end: 'bottom top',
          scrub: 1.5
        }
      });
    }

    /* ---- ABOUT LEAD TEXT ---- */
    const aboutLead = document.querySelector('.about-lead');
    if (aboutLead) {
      gsap.from(aboutLead, {
        y: 40, opacity: 0, duration: 1.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: aboutLead,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      });
    }

    /* ---- ABOUT SECTIONS ---- */
    document.querySelectorAll('.about-section').forEach((section, i) => {
      gsap.from(section, {
        y: 50, opacity: 0,
        duration: 0.9,
        delay: i * 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      });
    });

    /* ---- VALUES GRID ---- */
    const valuesGrid = document.querySelector('.values-grid');
    if (valuesGrid) {
      gsap.from(valuesGrid.children, {
        opacity: 0, y: 40,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: valuesGrid,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      });
    }

    /* ---- COLLECTION HEADER PARALLAX ---- */
    const collectionBg = document.querySelector('.collection-header-bg');
    if (collectionBg) {
      gsap.to(collectionBg, {
        x: 60,
        ease: 'none',
        scrollTrigger: {
          trigger: '.collection-header',
          start: 'top bottom',
          end: 'bottom top',
          scrub: 2
        }
      });
    }

    /* ---- PRODUCT PAGE GALLERY ---- */
    const productGallery = document.querySelector('.product-gallery');
    const productDetails = document.querySelector('.product-details');
    if (productGallery) {
      gsap.from(productGallery, {
        x: -40, opacity: 0, duration: 1,
        ease: 'power3.out'
      });
    }
    if (productDetails) {
      gsap.from(productDetails, {
        x: 40, opacity: 0, duration: 1,
        ease: 'power3.out',
        delay: 0.15
      });
    }

    /* ---- FOOTER REVEAL ---- */
    const footerGrid = document.querySelector('.footer-grid');
    if (footerGrid) {
      gsap.from(footerGrid.children, {
        y: 30, opacity: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: footerGrid,
          start: 'top 90%',
          toggleActions: 'play none none none'
        }
      });
    }

    /* ---- SECTION LINK UNDERLINE HOVER ---- */
    document.querySelectorAll('.section-link').forEach(el => {
      gsap.from(el, {
        opacity: 0, x: 10, duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          toggleActions: 'play none none none'
        }
      });
    });

    /* ---- COLLECTION HEADER TEXT ---- */
    const collectionTitle = document.querySelector('.collection-title');
    if (collectionTitle) {
      gsap.from(collectionTitle, {
        y: 60, opacity: 0, duration: 1.1,
        ease: 'power4.out'
      });
    }

    /* ---- CONTACT FORM FIELDS ---- */
    const formFields = document.querySelectorAll('.form-field');
    if (formFields.length) {
      gsap.from(formFields, {
        y: 24, opacity: 0,
        duration: 0.7,
        stagger: 0.08,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.contact-form',
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      });
    }
/* ---- ABOUT PAGE BELIEFS SECTION ---- */
    var beliefHeading = document.querySelector('.belief-heading');
    if (beliefHeading) {
      gsap.set('.belief-heading', { y: 30 });
      gsap.to('.belief-heading', {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '#beliefs-section',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
      gsap.set('.belief-col', { y: 40 });
      gsap.to('.belief-col', {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
        stagger: 0.25,
        scrollTrigger: {
          trigger: '#beliefs-section',
          start: 'top 70%',
          toggleActions: 'play none none none'
        }
      });
    }
  } // end initAnimations



  /* ============================================
     CONTACT FORM SUBMISSION
     ============================================ */
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = contactForm.querySelector('.btn-submit');
      if (btn) {
        btn.textContent = 'Sending...';
        btn.disabled = true;
      }
      // Shopify handles form submission natively when action="/contact"
      contactForm.submit();
    });
  }

  /* ============================================
     HERO WORD WRAPPER
     Wraps each word in .hero-headline for GSAP
     ============================================ */
  const heroHeadline = document.querySelector('.hero-headline');
  if (heroHeadline) {
    const html = heroHeadline.innerHTML;
    // Split on spaces but preserve HTML tags like <em>
    const wrapped = html.replace(/(\S+)/g, (match) => {
      // Don't wrap HTML tags
      if (match.startsWith('<') || match.endsWith('>')) return match;
      return `<span class="word" style="display:inline-block;overflow:hidden"><span style="display:inline-block">${match}</span></span>`;
    });
    heroHeadline.innerHTML = wrapped;
  }

});
